"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m3 8.41 9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7z"
}), 'CallMissedOutgoingSharp');